<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
    <div style="display: flex; align-items: center;">
        <p class="modal-title">{{data.nzTitle}}</p>
    </div>
</div>
<div #modalContent class="w-full h-full p-0 m-0">
    @if (isLoading) {
	    <app-loader></app-loader>
	}
	@else{
        @if (pauses && pauses.length > 0) {
        <nz-table #basicTable [nzData]="pauses" class="m-0 p-0" nzSize="small" [nzLoading]="isLoading" nzTableLayout="auto"
            [nzBordered]="true" [nzFrontPagination]="false" [nzShowPagination]="false"
            [nzScroll]="{ y: (tableHeight || 0) + 'px', x:'240px' }">
            <thead>
                <tr>
                    <th nzWidth="300px">Motivo</th>
                    <th nzWidth="300px">Observaciones</th>
                    <th nzWidth="150px">Fecha inicio</th>
                    <th nzWidth="125px">Iniciada por</th>
                    <th nzWidth="150px">Fecha fin</th>
                    <th nzWidth="125px">Reanudada por</th>
                    <th nzWidth="100px">Duración</th>
                    @if (canEdit()) {
                    <th nzRight nzWidth="100px">Acciones</th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (pause of basicTable.data; track pause) {
                <tr [class]="pause.pauseReason ? '':'bg-red-100'">
                    <td>{{ pause.pauseReason?.name ?? 'Pausa pendiente de motivar' }}</td>
                    <td>{{ pause.observations }}</td>
                    <td class="text-right">
                        {{ pause.startDate | date: ("dd/MM/YYYY HH:mm:ss")}}
                    </td>
                    <td>{{ pause.pausedBy ? pause.pausedBy.name : "-" }}</td>
                    <td class="text-right">
                        {{
                        pause.endDate === null
                        ? "-"
                        : (pause.endDate
                        | date: ("dd/MM/YYYY HH:mm:ss"))}}
                    </td>
                    <td>{{ pause.resumedBy ? pause.resumedBy.name : "-" }}</td>
                    <td class="text-right">
                        {{
                        pause.endDate === null
                        ? "-"
                        : milisecondsToFormatTime(
                        pause.startDate,
                        pause.endDate
                        )
                        }}
                    </td>
                    @if (canEdit()) {
                    <td nzRight>
                        <div class="flex align-middle justify-center">
                            <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                [nzTooltipTitle]="'Editar pausa'" nzTooltipPlacement="bottom" nz-tooltip
                                (click)="editPause(pause)"
                                [disabled]="!canReadSubKey('canEditOtherUsers') && (userLogged.id !== pause.pausedById || userLogged.id !== pause.resumedById)">
                                <span nz-icon nzType="form"></span>
                            </button>
                        </div>
                    </td>
                    }
                </tr>
                }
            </tbody>
        </nz-table>
        }
        @else {
        <div class="w-full h-full content-center">
            <nz-empty></nz-empty>
        </div>
        }
    }
</div>

<div *nzModalFooter>
    <div class="flex justify-end">
        <button (click)="handleCancel()" class="button secondary-button">
            Cerrar
        </button>
    </div>
</div>